import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import Studio from "@/pages/Studio";
import Gear from "@/pages/Gear";
import PrevWork from "@/pages/PrevWork";
import Contact from "@/pages/Contact";
import { AuthProvider } from "@/admin/AuthContext";
import { trackView } from "@/lib/api";
import AdminLogin from "@/admin/AdminLogin";
import { AdminLayout } from "@/admin/AdminLayout";
import Dashboard from "@/admin/Dashboard";
import PhotosAdmin from "@/admin/PhotosAdmin";
import GearAdmin from "@/admin/GearAdmin";
import CreditsAdmin from "@/admin/CreditsAdmin";
import AnalyticsAdmin from "@/admin/AnalyticsAdmin";
import SettingsAdmin from "@/admin/SettingsAdmin";

const ScrollTop = () => {
  const { pathname, search, key } = useLocation();
  useEffect(() => {
    // "instant" so it never animates, and keyed on `key` so re-clicking the
    // link you are already on still jumps back to the top.
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    if (window.gtag) window.gtag("event", "page_view", { page_path: pathname });
    if (!pathname.startsWith("/admin")) trackView(pathname);
  }, [pathname, search, key]);
  return null;
};

const pub = (el) => <Layout>{el}</Layout>;
const adm = (el) => <AdminLayout>{el}</AdminLayout>;

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ScrollTop />
        <Routes>
          <Route path="/" element={pub(<Home />)} />
          <Route path="/studio" element={pub(<Studio />)} />
          <Route path="/gear" element={pub(<Gear />)} />
          <Route path="/prev-work" element={pub(<PrevWork />)} />
          <Route path="/contact" element={pub(<Contact />)} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={adm(<Dashboard />)} />
          <Route path="/admin/dashboard" element={adm(<Dashboard />)} />
          <Route path="/admin/photos" element={adm(<PhotosAdmin />)} />
          <Route path="/admin/gear" element={adm(<GearAdmin />)} />
          <Route path="/admin/credits" element={adm(<CreditsAdmin />)} />
          <Route path="/admin/analytics" element={adm(<AnalyticsAdmin />)} />
          <Route path="/admin/settings" element={adm(<SettingsAdmin />)} />
          <Route path="*" element={pub(<Home />)} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
